export type { ProfileWebFragmentState } from './reducer';
export { profileWebFragmentReducer } from './reducer';
